<template>
  <panel>
    <div v-if="loadedSchema" class="row">
      <div class="col-md-12">
        <w-warnings :model="$schema" :display-errors="true" />
      </div>
    </div>
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import { EntityType } from '@/enums/entityType.enum';
import { Options } from '@/enums/options.enum';
import { editMixin } from '@/mixins/edit';
import { formRenderContainerMixin } from '@/mixins/formRenderContainer';

// @vuese
// Wykaz błędów dokumentu
// @group document
export default {
  components: { Panel },
  mixins: [{ ...formRenderContainerMixin, mounted: undefined }, editMixin('document')],
  computed: mapState({
    stateData(state) {
      return {
        ...state.document.data,
        comment: '',
        data: state.document.data.data || {},
        childrenModels: state.document.data.children,
        attachments: state.document.attachment.list.filter(function(attachment) {
          return (
            attachment.entityId === this.$route.params.documentId.toString() &&
            attachment.entityType === EntityType.DOCUMENT
          );
        }, this)
      };
    },
    settings: state => state.setting.settings,
    termPassed: state => state.optionValue.options[Options.TERM_PASSED].value
  }),
  mounted() {
    this.$options.external = {
      termPassed: this.termPassed === 'true',
      settings: this.settings
    };
    if (this.stateData?.data?.tenderer?.pesel) {
      this.stateData.data.tenderer.peselInput = this.stateData.data.tenderer.pesel;
    }
    this.loadSchema();
  }
};
</script>
